import Grid from "theme/layouts/Grid";
import ProductMap from "theme/components/products/ProductGrid/ProductMap";
import PropTypes from "prop-types";
import React from "react";
import productProp from "core-web/utils/proptypes/product";

const ProductGrid = ({ displayCampaignAreas, isDistinct, gridContent, products, isFirstModule, isLandingPage }) => {
    return (
        <Grid columns={[2, null, null, 3, 4]} columnGap={["16px", null, null, null, "24px"]}>
            <ProductMap
                displayCampaignAreas={displayCampaignAreas}
                isDistinct={isDistinct}
                gridContent={gridContent}
                products={products}
                isFirstModule={isFirstModule}
                isLandingPage={isLandingPage}
            />
        </Grid>
    );
};

ProductGrid.propTypes = {
    displayCampaignAreas: PropTypes.bool,
    gridContent: PropTypes.array,
    isDistinct: PropTypes.bool,
    isFirstModule: PropTypes.bool,
    isLandingPage: PropTypes.bool,
    products: PropTypes.arrayOf(productProp).isRequired,
};

ProductGrid.defaultProps = {
    displayCampaignAreas: false,
    gridContent: [],
    isDistinct: true,
    isFirstModule: false,
    isLandingPage: false,
};

export default ProductGrid;
